import { inputSumUseCase } from "./inputSum.case";
import { validateSum } from "./validateSum.case";
import { formatValue, kopeikiToRubles, unformatValue } from "../utils";
import { templateParser } from "../../../../../../../../../../../utils/strings";
export var getMapStateToSumInputProps = function getMapStateToSumInputProps(_ref) {
  var getContent = _ref.getContent,
    Component = _ref.Component;
  return function (getState, setState) {
    var state = getState();
    var content = getContent();
    var sumInput = content.sumInput;
    var handleSumChange = function handleSumChange(value) {
      var _unformatValue;
      var formattedValue = (_unformatValue = unformatValue(value)) !== null && _unformatValue !== void 0 ? _unformatValue : '';
      inputSumUseCase({
        getContent: getContent
      })(formattedValue, setState);
    };
    var handlePriceTagClick = function handlePriceTagClick(price) {
      inputSumUseCase({
        getContent: getContent
      })("".concat(price), setState);
    };
    var placeholder = templateParser(sumInput.placeholder, {
      min: kopeikiToRubles(content.paymentParams.amount.min),
      max: kopeikiToRubles(content.paymentParams.amount.max)
    });
    return {
      Component: Component,
      inputProps: {
        isLoading: state.isLoading,
        label: sumInput.label,
        onBlur: function onBlur() {
          return validateSum({
            getContent: getContent
          })(getState, setState);
        },
        onChange: handleSumChange,
        onClick: function onClick() {},
        placeholder: placeholder,
        value: formatValue(unformatValue(state.sumInput.value)),
        disabled: state.sumInput.isDisabled,
        error: state.sumInput.errorMessage,
        postFix: sumInput.postFix,
        maxLength: sumInput.maxLength
      },
      pricesProps: {
        isLoading: state.isLoading,
        props: sumInput.priceTags.map(function (price) {
          return {
            children: "".concat(price),
            onClick: function onClick() {
              return handlePriceTagClick(price);
            },
            isSelected: price === Number(state.sumInput.value)
          };
        })
      }
    };
  };
};